import cx from 'classnames';
import { MAIN_NAV_TRACK } from '../../../../constants/analyticsConstants';
import { CatButton } from '@blocks-react/components/Button';
import { HeaderEquipmentButtonProps } from '../types';
import styles from '../HeaderEquipmentWidget.module.scss';

export const HeaderEquipmentButton = ({
  clickHandler,
  hasSelectedEquipment,
  isFeatureFlag = false,
  subLabel = '',
  size = '',
  children
}: HeaderEquipmentButtonProps) => {
  const buttonClassnames = {
    [styles['header-equipment-button__search-banner']]: subLabel,
    [styles['header-equipment-button__non-search-banner']]: !subLabel,
    [styles['header-equipment-button__isheader']]:
      isFeatureFlag && size == 'md',
    [styles['header-equipment-button__isbanner']]: isFeatureFlag && size == 'lg'
  };

  return (
    <CatButton
      slot="trigger"
      className={cx(
        'flex-shrink-0',
        styles['header-equipment-button'],
        buttonClassnames
      )}
      data-testid="headerWidgetButton"
      id="headerEquipmentWidget"
      onClick={clickHandler}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={
        hasSelectedEquipment
          ? MAIN_NAV_TRACK.CURRENTLY_SHOPPING_DRAWER_TEXT
          : MAIN_NAV_TRACK.SELECT_EQUIPMENT_TEXT
      }
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
    >
      <div
        className={cx(
          { 'd-flex align-items-center': isFeatureFlag },
          {
            'd-flex align-items-center': !subLabel,
            'd-flex': subLabel
          },
          styles['header-equipment-button__wrapper']
        )}
      >
        {children}
      </div>
    </CatButton>
  );
};
